export default {
  title: 'LA PÁGINA QUE BUSCAS DEBE ESTAR POR AQUÍ...',
  description: '¿Buscas alguna de las páginas de abajo?',
  not_found: 'No encontramos la URL introducida. Comprueba si fue introducida correctamente.',
  no_restaurants: {
    title: 'Esta tienda aún no está abierta para pedidos en línea',
    description: 'Vuelve a consultar pronto.',
  },
  toasts: {
    failed_to_load_stores: 'Error al cargar las tiendas, actualiza la página',
  },
};
